import styled from "styled-components";

export const MainWrapper = styled.main`
  width: 80%;
  margin: auto;
`;